module.exports = __webpack_public_path__ + "img/cong.e1f3e344.png";